import React from "react";
import Newcard from "../Card/Newcard"
import { Grid, Grow, Typography } from '@material-ui/core'
import useStyles from './style.js'

const Newscard = ({ articles , activearticle }) => {
    const classes = useStyles();
    if (!articles.length) {
        return (<>
            <center><img src={"https://media-exp1.licdn.com/dms/image/C561BAQFzAiAvq0Jg8Q/company-background_10000/0/1565260089604?e=2159024400&v=beta&t=ygcEIMzRHClwTjBwChX2naoGiS2TCeDwozFfEAM73ek"} className={classes.image} alt="" /></center>
            <div className={classes.container1}>
                <div className={classes.cards}>
                    <h3><strong>About the Project</strong></h3>
                    <h4>Try saying:</h4>
                    <h4><strong>Tell me about the project</strong></h4>
                    <h3><strong>About working</strong></h3>
                    <h4>Try saying:</h4>
                    <h4><strong>What this project can do?</strong></h4>
                </div>
                <div className={classes.cards}>
                    <h3><strong>Latest news</strong></h3>
                    <h4>Try saying:</h4>
                    <h4><strong>Give me the Latest News</strong></h4>
                    <h5>After showing the latest news </h5>
                    <h5>if you want me to read it</h5>
                    <h5>Try saying: yes (after I ask you)</h5>
                </div>
                <div className={classes.cards}>
                    <h3><strong>News by term:</strong></h3>
                    <h4>Try Saying:</h4>
                    <h4><strong>What is up with the ("term")?</strong></h4>
                    <h5>Example:</h5>
                    <h5>What is up with coronavirus?</h5>
                </div>
                <div className={classes.cards}>
                    <h3><strong>Open Article:</strong></h3>
                    <h4>Try saying:</h4>
                    <h3>Open Article Number (number)</h3>
                    <h3><strong>Open portfolio:</strong></h3>
                    <h4>Try saying:</h4>
                    <h3>Open the Portfolio</h3>
                </div>
            </div>
            </>
        )
    }
    return (
        <Grow in>
            <Grid className={classes.container} container alignItems="stretch" spacing={3}>
                {articles.map((articles, i) => (
                    <Grid key={i} item xs={12} sm={6} md={4} lg={3} style={{ display: 'flex' }}>
                        <Newcard article={articles} activearticle={activearticle} i={i} />
                    </Grid>
                ))}
            </Grid>
        </Grow>
    )
}

export default Newscard;